import { ContextFormByIdProvider, IContextFormByIdBeforeMount } from "@ngt/forms";
import { FC, PropsWithChildren } from "react";
import { FormDefinitions } from "../../api/dtos";
import { useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";

export interface IProjectFormByIdRouteProps extends PropsWithChildren {
    projectId?: number | undefined;

    loadBeforeMount?: boolean | IContextFormByIdBeforeMount;
    validateBeforeMount?: boolean | IContextFormByIdBeforeMount;
}

const ProjectFormByIdRoute: FC<IProjectFormByIdRouteProps> = ({
    projectId,
    loadBeforeMount,
    validateBeforeMount,
    children
}) => {
    const params = useParams();

    const projectIdToUse = (params.projectId ? +params.projectId : undefined) ?? projectId ?? undefined;

    return (
        <ContextFormByIdProvider
            formId={projectIdToUse}
            formDefinitionIdentifier={FormDefinitions.Project}

            loadBeforeMount={loadBeforeMount}
            LoadingComponent={CircularProgress}

            validateBeforeMount={validateBeforeMount}
            ValidatingComponent={CircularProgress}
        >
            {children}
        </ContextFormByIdProvider>
    );
}

export default ProjectFormByIdRoute;
